import moment from "moment";

import * as types from "../actions/actionTypes";

import { formatDate } from "../helpers/date";

import initialState from "./initialState";

export const calls = (state = initialState.calls, action) => {
  switch (action.type) {
    case types.LOAD_CALL_SUCCESS:
      return action.calls;

    case types.CREATE_CALL_SUCCESS:
      return state.calls
        ? { ...state, calls: [...state.calls, { ...action.call }] }
        : [...state, { ...action.call }];

    case types.UPDATE_CALL_SUCCESS: {
      return state.calls
        ? {
            ...state,
            calls: [
              ...state.calls.filter((c) => c._id !== action.call._id),
              { ...action.call }
            ]
          }
        : [
            ...state.filter((c) => c._id !== action.call._id),
            { ...action.call }
          ];
    }

    case types.DELETE_CALL_SUCCESS:
      return state.calls
        ? {
            ...state,
            calls: state.calls.filter((c) => c._id !== action.callId)
          }
        : [...state.filter((c) => c._id !== action.callId)];

    default:
      return state;
  }
};

export const call = (state = initialState.call, action) => {
  switch (action.type) {
    case types.GET_CALL_SUCCESS:
      return action.call;

    case types.RESET_CALL_SUCCESS:
      return action.call;

    default:
      return state;
  }
};

export const savingCall = (state = initialState.savingCall, action) => {
  switch (action.type) {
    case types.SAVING_CALL:
      return action.savingCall;

    default:
      return state;
  }
};

export const callToSave = (state = initialState.callToSave, action) => {
  switch (action.type) {
    case types.REQUEST_CALL_SAVE:
      return action.callToSave;

    default:
      return state;
  }
};

export const callToDelete = (state = initialState.callToDelete, action) => {
  switch (action.type) {
    case types.REQUEST_CALL_DELETE:
      return action.callToDelete;

    default:
      return state;
  }
};

export const callsToApprove = (state = initialState.callsToApprove, action) => {
  switch (action.type) {
    case types.TOGGLE_CALL: {
      // start off with the existing state
      let innerCallsToApprove = [...state];

      const keyIndex = innerCallsToApprove.indexOf(action.id);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        innerCallsToApprove = [
          ...callsToApprove.slice(0, keyIndex),
          ...callsToApprove.slice(keyIndex + 1)
        ];
      } else {
        // it does not exist so add it
        innerCallsToApprove.push(action.id);
      }

      // console.log("callsToApprove", callsToApprove);
      return [...innerCallsToApprove];
    }

    case types.DESELECT_ALL_CALLS: {
      return [];
    }

    default:
      return state;
  }
};

export const recurringCalls = (state = initialState.recurringCalls, action) => {
  switch (action.type) {
    case types.GET_RECURRING_CALLS_SUCCESS: {
      return action.calls;
    }

    case types.TOGGLE_RECURRING_CALL: {
      // start off with the existing state
      let innerRecurringCalls = [...state];

      const keyIndex = innerRecurringCalls.indexOf(action.id);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        innerRecurringCalls = [
          ...recurringCalls.slice(0, keyIndex),
          ...recurringCalls.slice(keyIndex + 1)
        ];
      } else {
        // it does not exist so add it
        innerRecurringCalls.push(action.id);
      }

      return [...innerRecurringCalls];
    }

    case types.DESELECT_ALL_CALLS: {
      return [];
    }

    case types.CREATE_CALL_SUCCESS:
      return [];

    case types.UPDATE_CALL_SUCCESS:
      return [];

    default:
      return state;
  }
};

export const recurrence = (state = initialState.recurrence, action) => {
  switch (action.type) {
    case types.GET_RECURRENCE_SUCCESS:
      return action.recurrence;

    case types.CREATE_CALL_SUCCESS:
      return {};

    default:
      return state;
  }
};

export const range = (state = initialState.range, action) => {
  switch (action.type) {
    case types.GET_DATE_RANGE_SUCCESS: {
      let period = action.range;
      period = period.split(" - ");

      const start = new Date(period[0]);
      const end = new Date(period[1]);
      const dates = [start];
      const year = start.getFullYear();
      const month = start.getMonth();
      let date = start.getDate();
      while (dates[dates.length - 1] < end) {
        dates.push(new Date(year, month, ++date));
      }

      return dates.map((d) => ({
        day: formatDate(d, "eee").toLowerCase(),
        date: formatDate(d, "MM/dd/yy"),
        num: moment(d).day(),
        display: formatDate(d, "MM/dd")
      }));
    }
    default:
      return state;
  }
};

export const partToDelete = (state = initialState.partToDelete, action) => {
  switch (action.type) {
    case types.REQUEST_PART_ID:
      return action.partToDelete;

    default:
      return state;
  }
};

export const callCount = (state = initialState.callCount, action) => {
  switch (action.type) {
    case types.GET_CALL_COUNT_SUCCESS:
      return action.callCount;

    default:
      return state;
  }
};

export const callApprovalToNotify = (
  state = initialState.callApprovalToNotify,
  action
) => {
  switch (action.type) {
    case types.GET_CALL_APPROVAL_TO_NOTIFY:
      return action.callApprovalToNotify;

    default:
      return state;
  }
};
